// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import ExportControls from '@aytm/app/stats/page/question-views/oe/components/Controls/Export'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/items/Controls.module.scss'

const Controls = ({
  model,
  features,
  disabled,
  isWCType,
  isVerbatimType,
  isSurveyGuest,
  onChartModeChange,
  onExport
}) => {
  const { chartMode } = model

  return disabled ? null : (
    <div className={`${style.component} p-fluid`}>
      {isWCType ? (
        <div className="p-fluid p-field p-right">
          <span className={style['chat-mode-toggle']} onClick={onChartModeChange}>
            {'wc' == chartMode ? 'switch to chart' : 'switch to wordcloud'}
          </span>
          {isVerbatimType ? (
            <ExportControls model={model} features={features} isSurveyGuest={isSurveyGuest} onExport={onExport} />
          ) : null}
        </div>
      ) : isVerbatimType ? (
        <ExportControls model={model} features={features} isSurveyGuest={isSurveyGuest} onExport={onExport} />
      ) : null}
    </div>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  features: PropTypes.object,
  disabled: PropTypes.bool,
  isWCType: PropTypes.bool,
  isVerbatimType: PropTypes.bool,
  isSurveyGuest: PropTypes.bool,
  onChartModeChange: PropTypes.func,
  onExport: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
